import type { Coach, CoachVideo, GetCoaches } from '@entities/coaches/types.ts';
import { AxiosInstance } from 'axios/index';
import { EntityByIdParam, ModuleParam } from '@src/api/types.ts';

export class CoachesApi {
  constructor(private instance: AxiosInstance) {}

  public async getList(params: CoachesListParams) {
    return this.instance.get<GetCoaches>(`users/coach/`, { params }).then((res) => res.data);
  }

  public async getById({ id }: EntityByIdParam) {
    return this.instance.get<Coach>(`users/coach/${id}`).then((res) => res.data);
  }

  public async getPresentVideo({ id }: EntityByIdParam) {
    return this.instance.get<CoachVideo>(`videos/coach_video/${id}/`).then((res) => res.data);
  }
}

export type CoachesListParams = Partial<
  ModuleParam & {
    page: number;
    consultations_type: string;
    city: string;
    tags: string;
    partitions: string;
    search: string;
  }
>;
